import { insertLeadsDumpData } from "@/lib/utils";
import React, { useState } from "react";

const HireFromMilesForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    location: "",
    consent: true,
  });

  const [phoneError, setPhoneError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isBrochureFormSubmitted, setBrochureFormSubmitted] = useState(false);

  //considering that we are not going to get leads from outside india, hence havent used the validationCheck logic for multiple countries
  const validatePhone = (phone: string) => {
    // Check if the phone number contains any letters
    if (/[a-zA-Z]/.test(phone)) {
      return false;
    }
    // Check for the specific formats
    const phoneRegex = /^(\+91|91|0)?[6-9]\d{9}$/;
    return phoneRegex.test(phone);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;

    if (name === "phone") {
      // Only allow digits, '+', and leading zero
      const sanitizedValue = value.replace(/[^\d+]/g, "");
      setFormData((prevData) => ({
        ...prevData,
        [name]: sanitizedValue,
      }));
      if (sanitizedValue === "") {
        setPhoneError("");
      } else if (validatePhone(sanitizedValue)) {
        setPhoneError("");
      } else {
        setPhoneError("Please enter a valid phone number");
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!validatePhone(formData.phone)) {
      setPhoneError("Please enter a valid phone number");
      return;
    }

    setIsSubmitting(true);

    try {
      let payload = {
        first_name: formData.name,
        email: formData.email,
        phone: formData.phone,
        city: formData.location,
        whatsapp: formData.consent,
        course: 6,
        coming_from: "Hire-From-Miles-Website-page",
        page_full_url: window.location.href,
      };

      const { error } = await insertLeadsDumpData(payload);

      if (!error) {
        setFormData({
          name: "",
          email: "",
          phone: "",
          location: "",
          consent: false,
        });
        setBrochureFormSubmitted(true);
      } else {
        throw new Error("Form submission failed");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-full">
      <div className="flex flex-col md:flex-row md:gap-5 gap-[20px] pt-[0px] relative">
        <div className=" w-full md:mt-0">
          <div className="mx-auto w-full max-w-[567px] py-5 rounded-lg px-0">
            <h3 className="text-[#0C1F33] md:text-[28px] text-center font-semibold mb-5">
              Hire From Miles Talent Pool!{" "}
            </h3>
            {!isBrochureFormSubmitted ? (
              <form className="space-y-5" onSubmit={handleSubmit}>
                <div className="w-full flex flex-col gap-5">
                  <label htmlFor="name" className="sr-only">
                    Full Name
                  </label>
                  <input
                    id="name"
                    type="text"
                    placeholder="Full Name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="flex-1 p-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                  />
                  <label htmlFor="email" className="sr-only">
                    Email Address
                  </label>
                  <input
                    id="email"
                    type="email"
                    placeholder="E-mail"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="flex-1 p-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                  />
                </div>
                <div className="w-full flex flex-col gap-5 justify-between">
                  <label htmlFor="phone" className="sr-only">
                    Phone Number
                  </label>
                  <input
                    id="phone"
                    type="text"
                    placeholder="Phone number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    className="flex-1 p-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                  />
                  {phoneError && (
                    <p className="text-red-500 text-sm ">{phoneError}</p>
                  )}
                  <label htmlFor="location" className="sr-only">
                    Location
                  </label>
                  <input
                    id="location"
                    type="text"
                    placeholder="Location"
                    name="location"
                    value={formData.location}
                    onChange={handleInputChange}
                    required
                    className="flex-1 p-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                  />
                </div>
                <span className="flex items-center">
                  <label className="flex items-center gap-1 md:gap-1 text-[#5D6A77] md:text-[14px] font-medium text-[12px] md:font-medium">
                    <input
                      className="w-3 h-3 ml-2"
                      type="checkbox"
                      name="consent"
                      checked={formData.consent}
                      onChange={handleInputChange}
                    />
                    Yes, connect with me on{" "}
                    <span className="text-[#002551] font-semibold">
                      WhatsApp, Email, SMS and Call
                    </span>
                  </label>
                  <div className="tooltip !px-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_795_9335)">
                        <path
                          d="M6.66842 4.33413H7.73645V5.40215H6.66842V4.33413ZM6.66842 6.47018H7.73645V9.67426H6.66842V6.47018ZM7.20244 1.66406C4.25468 1.66406 1.8623 4.05644 1.8623 7.00419C1.8623 9.95195 4.25468 12.3443 7.20244 12.3443C10.1502 12.3443 12.5426 9.95195 12.5426 7.00419C12.5426 4.05644 10.1502 1.66406 7.20244 1.66406ZM7.20244 11.2763C4.84744 11.2763 2.93033 9.35919 2.93033 7.00419C2.93033 4.6492 4.84744 2.73209 7.20244 2.73209C9.55743 2.73209 11.4745 4.6492 11.4745 7.00419C11.4745 9.35919 9.55743 11.2763 7.20244 11.2763Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_795_9335">
                          <rect
                            width="12.8163"
                            height="12.8163"
                            fill="white"
                            transform="translate(0.795898 0.59375)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    <span className="tooltiptext font-normal ">
                      By checking the ✓ box, you consent to receiving important
                      updates and relevant information about your journey with
                      Miles Education via WhatsApp, Email, SMS and Call. You can
                      always choose to opt-out in the future.
                    </span>
                  </div>
                </span>

                <div className="grp_btn w-full flex justify-center items-center">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="new__discover_btn w-full h-[42px] px-[50px] text-[16px] font-medium leading-[18px]"
                  >
                    {isSubmitting ? "Submitting..." : "Enquire Now"}
                  </button>
                </div>
              </form>
            ) : (
              <>
                <h2 className="text-2xl font-bold text-center mb-4">
                  Thank you for your interest in the Miles Talent Pool
                </h2>
                <p className="text-center">We will get back to you soon.</p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HireFromMilesForm;
